import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Router from './pages/Router';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectTheme } from './store/ui/ui.selector';
import ErrorBoundary from './components/ErrorBoundary';

const App = () => {
  const loadUsetifulScript = () => {
    const script = document.createElement('script');
    script.id = 'usetifulScript';
    script.src = 'https://www.usetiful.com/dist/usetiful.js';
    script.async = true;
    script.dataset.token = 'ca1abd4beb2720b298e72bfe75d09cf4';

    document.head.appendChild(script);
  };

  const theme = useSelector(selectTheme);

  useEffect(() => {
    loadUsetifulScript();
  }, []);

  useEffect(() => {
    document
      .getElementsByTagName('body')[0]
      ?.classList.remove('theme-default', 'theme-dark', 'theme-light');
    document
      .getElementsByTagName('body')[0]
      ?.classList.add(`theme-${theme ?? 'default'}`);
  }, [theme]);

  return (
    <div className='app'>
      <BrowserRouter>
        <ErrorBoundary>
          <Switch>
            <Route path='/'>
              <Router />
            </Route>
          </Switch>
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  );
};

export default App;
